// Generated by ReScript, PLEASE EDIT WITH CARE

import * as App from "./App.bs.js";
import * as React from "react";
import * as Belt_Option from "@rescript/runtime/lib/es6/Belt_Option.js";
import * as GlobalStyles from "./styles/GlobalStyles.bs.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as Client from "react-dom/client";
import * as JsxRuntime from "react/jsx-runtime";

import "@cosmonexus/design-tokens/css"
;

import "@cosmonexus/design-tokens/css/light"
;

import "@cosmonexus/design-tokens/css/dark"
;

import "./styles/theme-light.css"
;

GlobalStyles.initialize();

Client.createRoot(Belt_Option.getExn(Primitive_option.fromNullable(document.querySelector("#root")))).render(JsxRuntime.jsx(React.StrictMode, {
  children: JsxRuntime.jsx(App.App.make, {})
}));

/*  Not a pure module */
